import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import SpaCarosle from "../../Components/SpaCarosle";
import axios from "../../axios";
import Green from "../../assets/images/icons/green-leaf.png";
import { Button, Form, Modal } from "react-bootstrap";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import "react-phone-input-2/lib/style.css";
import "../../new-pages/hotel-services/HotelServices.scss";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import { Accordion, AccordionTab } from "primereact/accordion";
import TaxInclusive from "../../Components/TaxInclusive.";
import Title from "../../new-components/title/Title";
import BannerServices from "../../new-components/banner-home/BannerServices";
import HouseImage from "../../assets/images/housekeeping.jpeg";
import NewFooter from "../../NewFooter";
import { ThemeContext } from "../../context/ThemeContext";
import Sar from "../../assets/images/icons/Sar";
import { trackOrderPaymentFailed } from "../../utils/mixpanel";
import { toast } from "react-toastify";

function HouseKeeping() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  const [service, setService] = useState([]);
  // Selected quantity per service id, only for services with has_quantity.
  const [quantities, setQuantities] = useState({});
  const [showError, setShowError] = useState(false);
  const [loading, setLaoding] = useState(false);
  const [title, setTitle] = useState();
  const [hcServices, setHcServices] = useState();
  const [hasOnlinePayment, setHasOnlinePayment] = useState(false);
  const [h_images, seth_images] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState("");
  const [order, setOrder] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const loaderRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const { t, i18n } = useTranslation();
  // const theme = rawPath.includes("hotel-services");
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);
  // console.log("theme", theme);

  // console.log("hotel-services", service);

  const toggleService = (input, name, working_times, has_quantity) => {
    console.log("working_times", working_times);
    // Selection changed after a payment was initiated: drop the iframe so
    // the next "request" re-books with the new services/price.
    if (paymentUrl) {
      setPaymentUrl("");
    }
    if (service.includes(input)) {
      ReactGA.event({
        category: "Add HouseKeeping",
        action: "Click",
        value: `HouseKeeping: ${name}`,
      });
      setService((prev) => {
        return prev.filter((x) => x !== input);
      });
      setQuantities((prev) => {
        const { [input]: _, ...rest } = prev;
        return rest;
      });
    } else {
      setService((prev) => [...prev, input]);
      if (has_quantity) {
        setQuantities((prev) => ({ ...prev, [input]: 1 }));
      }
    }
    console.log(service);
  };
  // Quantity starts at 1 and never drops below it. Deselecting is done
  // through the service button.
  const changeQuantity = (id, delta) => {
    if (paymentUrl) {
      setPaymentUrl("");
    }
    const next = Math.max(1, (quantities[id] || 1) + delta);
    setQuantities((prev) => ({ ...prev, [id]: next }));
  };

  // Only shown once the service is selected.
  const renderQuantity = (id, has_quantity) =>
    !!has_quantity &&
    service.includes(id) && (
      <div className="count-order-amount mx-auto mb-3">
        <Button className="small" onClick={() => changeQuantity(id, -1)}>
          <i className="fa fa-minus"></i>
        </Button>
        <p>{quantities[id] || 1}</p>
        <Button className="small" onClick={() => changeQuantity(id, 1)}>
          <i className="fa fa-plus"></i>
        </Button>
      </div>
    );

  const lang = localStorage.getItem("lang");
  const currency = localStorage.getItem("currency");
  const color = localStorage.getItem("color");
  const handleIframeLoad = () => {
    // Hide the loading view once the payment iframe is loaded
    if (loaderRef.current) {
      loaderRef.current.style.display = "none";
      loaderRef.current.style.visibility = "hidden";
      loaderRef.current.remove();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOrder((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Name / email / phone are only collected (and required) for online payment.
  const checkInputs = () => {
    let isValid = true;

    if (order.name == "") {
      setNameError("Name is a required field");
      isValid = false;
    } else {
      setNameError("");
    }

    if (!/\S+@\S+\.\S+/.test(order.email)) {
      setEmailError("The email must be a valid email address.");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (order.phone == "") {
      setPhoneError("Phone is a required field");
      isValid = false;
    } else {
      setPhoneError("");
    }

    return isValid;
  };

  const handleBook = () => {
    if (service.length <= 0) {
      setShowError(true);
    } else if (hasOnlinePayment && !checkInputs()) {
      setShowError(false);
    } else {
      setShowError(false);
      setIsDisabled(true);
      const payload = {
        services: service.map((id) => ({
          service_id: id,
          quantity: quantities[id] || 1,
        })),
      };
      if (hasOnlinePayment) {
        sessionStorage.setItem("hk_return_path", rawPath);
        payload.redirect_url = `https://${window.location.host}/${room_uuid}/HKCallback`;
        payload.name = order.name;
        payload.email = order.email;
        payload.phone = order.phone;
      }
      axios
        .post(`/${room_uuid}/house_keeping/book_service`, payload, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          setIsDisabled(false);
          if (res.data.status) {
            // When online payment is enabled, the book API mirrors the
            // checkout response (payment_url / is_embedded), so follow the
            // same flow. Otherwise keep the original behaviour.
            if (hasOnlinePayment && res?.data?.data?.payment_url) {
              if (res?.data?.data?.is_embedded) {
                setPaymentUrl(res.data.data.payment_url);
              } else {
                window.location.href = res.data.data.payment_url;
              }
            } else {
              navigate(`/${room_uuid}/HKOrderPlaced`);
            }
          }
        })
        .catch((err) => {
          setIsDisabled(false);
          // trackOrderPaymentFailed({
          //   order_number: "",
          //   amount: 0,
          //   payment_method: "",
          //   gateway: "",
          //   failure_reason: err?.message || "Order failed",
          // });
          console.log(err);
        });
    }
  };

  // The payment callback returns here with ?payment=failed when the guest
  // cancelled or the gateway declined.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("payment") === "failed") {
      toast.error(t(params.get("message") || "Payment was not completed"));
      navigate(rawPath, { replace: true });
    }
  }, []);

  useEffect(() => {
    const getData = async () => {
      setLaoding(true);
      axios
        .get(`/${room_uuid}/house_keeping`, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          if (res.data.status === false) {
            navigate(`/${room_uuid}/qr-scan`);
          } else {
            const data = res.data.data;
            setHcServices(data.houseKeepingServices);
            setTitle(data.title);
            seth_images(data.banners);
            setHasOnlinePayment(data.online_payment);
            console.log(data);
            setLaoding(false);
          }
        })
        .catch((err) => {
          if (err?.response.status == 404) {
            navigate(`/not-found`);
          }
        });
    };
    getData();
  }, []);
  // const price = 100;
  return (
    <div className={theme ? "food pb-0" : ""}>
      {theme ? <Title title={title} /> : <HeaderInner headerName={title} />}
      <main className="home-main bg-white back-white pad-top-0 house">
        {loading ? (
          <SpaLoader />
        ) : (
          <>
            {theme ? (
              <BannerServices headerImages={h_images} />
            ) : (
              <SpaCarosle
                noDots={true}
                autoPlay={true}
                isSalon={true}
                salonImg={h_images}
              />
            )}
            <div className="housekeeping-container">
              <p className="service">{t("Choose a Service")}</p>
              <div className="service-container">
                {hcServices &&
                  hcServices.map((prop) => {
                    const {
                      id,
                      name,
                      is_green,
                      activeSubCategories,
                      price,
                      description,
                      working_times,
                      has_quantity,
                    } = prop;

                    return (
                      <>
                        {activeSubCategories?.length > 0 ? (
                          <>
                            <Accordion
                              multiple
                              expandIcon="fa fa-plus"
                              collapseIcon="fa fa-minus"
                              className="mb-3 acor_house"
                            >
                              <AccordionTab
                                key={"Disclaimer"}
                                header={
                                  <>
                                    <span>{name}</span>
                                    {price != 0 && (
                                      <span className="house_price">
                                        {price}{" "}
                                        {currency === "SAR" ? (
                                          <Sar color="currentcolor" />
                                        ) : (
                                          `${currency} `
                                        )}
                                      </span>
                                    )}
                                  </>
                                }
                                disabled={false}
                              >
                                {activeSubCategories?.map((item) => {
                                  return (
                                    <>
                                      <Button
                                        className={
                                          service.includes(item.id)
                                            ? `reg-btn outline-btn dark d-flex justify-content-center  ${
                                                item.is_green == 1
                                                  ? "is_green"
                                                  : ""
                                              }`
                                            : "reg-btn outline-btn d-flex justify-content-center "
                                        }
                                        style={
                                          service.includes(item.id)
                                            ? {
                                                backgroundClor: "#006390",
                                                marginBottom: "10px",
                                                marginTop: "5px  ",
                                              }
                                            : {
                                                marginBottom: "10px",
                                                marginTop: "5px  ",
                                              }
                                        }
                                        onClick={() =>
                                          toggleService(
                                            item.id,
                                            item.name,
                                            working_times,
                                            item.has_quantity,
                                          )
                                        }
                                      >
                                        <span>{item.name}</span>

                                        {item?.price != 0 && (
                                          <span className="house_price">
                                            {item?.price}{" "}
                                            {currency === "SAR" ? (
                                              <Sar color="currentcolor" />
                                            ) : (
                                              `${currency} `
                                            )}
                                          </span>
                                        )}
                                        {item.is_green == 1 && (
                                          <img
                                            className="green_img"
                                            src={Green}
                                            alt=""
                                            width={25}
                                            height={25}
                                          />
                                        )}
                                      </Button>
                                      {renderQuantity(
                                        item.id,
                                        item.has_quantity,
                                      )}
                                      {item.description && (
                                        <p className="desc">
                                          {item.description}
                                        </p>
                                      )}
                                    </>
                                  );
                                })}
                              </AccordionTab>
                            </Accordion>
                            {description && (
                              <>
                                <p className="desc">{description}</p>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <Button
                              className={
                                service.includes(id)
                                  ? `reg-btn outline-btn dark d-flex justify-content-center  ${
                                      is_green == 1 ? "is_green" : ""
                                    }`
                                  : "reg-btn outline-btn d-flex justify-content-center "
                              }
                              style={
                                service.includes(id)
                                  ? {
                                      backgroundClor: "#006390",
                                    }
                                  : {}
                              }
                              onClick={() =>
                                toggleService(
                                  id,
                                  name,
                                  working_times,
                                  has_quantity,
                                )
                              }
                            >
                              <span>{name}</span>
                              {price != 0 && (
                                <span className="house_price">
                                  {price}{" "}
                                  {currency === "SAR" ? (
                                    <Sar color="currentcolor" />
                                  ) : (
                                    `${currency} `
                                  )}
                                </span>
                              )}
                              {is_green == 1 && (
                                <img
                                  className="green_img"
                                  src={Green}
                                  alt=""
                                  width={25}
                                  height={25}
                                />
                              )}
                            </Button>
                            {renderQuantity(id, has_quantity)}
                            {description && (
                              <>
                                <p className="desc">{description}</p>
                              </>
                            )}
                          </>
                        )}
                      </>
                    );
                  })}
              </div>
              {showError ? (
                <p className="no-service">{t("Choose a service")} </p>
              ) : null}
              {hasOnlinePayment && !paymentUrl && (
                <div className="housekeeping-form">
                  <Form.Group className="mb-3" controlId="formBasicName">
                    <Form.Control
                      type="text"
                      placeholder={t("Your Name")}
                      name="name"
                      value={order.name}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                  {nameError && (
                    <span className="err_msg">{t(`${nameError}`)} </span>
                  )}

                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control
                      type="email"
                      placeholder={t("Your Email")}
                      name="email"
                      value={order.email}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                  {emailError && (
                    <span className="err_msg">{t(`${emailError}`)} </span>
                  )}

                  <Form.Group className="mb-3 w-100">
                    <PhoneInputComponent
                      value={order.phone}
                      onChange={(phone) => {
                        setOrder((prev) => ({
                          ...prev,
                          phone,
                        }));
                      }}
                    />
                  </Form.Group>
                  {phoneError && (
                    <span className="err_msg">{t(`${phoneError}`)} </span>
                  )}
                </div>
              )}
              {!paymentUrl && (
                <div className="book">
                  <Button
                    onClick={handleBook}
                    disabled={isDisabled}
                    className="reg-btn"
                  >
                    {t("request")}
                  </Button>
                  {/* <h3 className="text-center">
                  <TaxInclusive />
                </h3> */}
                </div>
              )}
              {paymentUrl && (
                <div className="payment-iframe">
                  <div
                    className="d-flex justify-content-center m-5"
                    ref={loaderRef}
                  >
                    <div
                      className="loader"
                      style={{
                        borderColor: "lightgray",
                        borderRightColor: "#000000",
                      }}
                    ></div>
                  </div>
                  <iframe
                    loading="lazy"
                    src={paymentUrl}
                    width="100%"
                    title="Payment Preview"
                    scrolling="no"
                    onLoad={handleIframeLoad}
                  ></iframe>
                </div>
              )}
            </div>
          </>
        )}
      </main>
      {theme && <NewFooter />}
    </div>
  );
}
export default HouseKeeping;
